import "./Copyright.scss";
import AnimatedLink from "../AnimatedLink/AnimatedLink";

const Credits = ({classesName}) => {
  return (
    <p className={`copyright ${classesName? classesName : ""}`}>
      Design by <AnimatedLink text="VaysLu" href="/" />
    </p>
  )
}

export default Credits;